import { Button } from "@/components/ui/button";

/** A row of buttons, one per value of a filter, the chosen one pressed. */
export function FilterChips<V extends string>({
  options,
  value,
  onChange,
}: {
  options: readonly { value: V; label: string }[];
  value: string;
  onChange: (next: V) => void;
}) {
  return (
    <>
      {options.map((option) => (
        <Button
          key={option.value}
          size="sm"
          variant={value === option.value ? "default" : "outline"}
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </>
  );
}
